export default () => {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};
